import React, { useContext } from 'react'

import { useModalContext } from '../../../context/modalProvider'
import { ModalTypes } from '../../../utils/constants'

import { RegisterModal } from '../../organisms/registerModal'
import { Flex } from '../../atoms/flex'
import { Spinner } from '../../atoms/spinner'
import { Modal } from '../modal'
import { CafIFrame } from '../../molecules/cafIFrame'
import QRModal from '../../molecules/qrModal'
import { Receipt } from '../../molecules/receipt'
import { ConfirmationModal } from '../../molecules/confirmationModal'
import { SimpleModal } from '../../molecules/simpleModal'
import { FormModal } from '../../molecules/formModal'
import Withdraw from '../../../components/payments/withdraw/withdraw'
import { AuthContext } from '../../../context/authProvider'
import { Simple2Modal } from '../../molecules/simple2Modal'

const ModalContainer = () => {
  const { modalStatus, type, data, title, close } = useModalContext()
  const { isLoggedIn } = useContext(AuthContext)

  const handleCancelClose = () => {
    if (data?.onCancel) data.onCancel()
    close()
  }

  if (!modalStatus) return <></>

  switch (type) {
    case ModalTypes.CAFIFRAME:
      return (
        <Modal
          isOpen={modalStatus}
          onClose={handleCancelClose}
          isTransparent={true}
          leftSideClose={true}
        >
          <CafIFrame
            chosenDocument={'LIVENESS'}
            closeIFrame={data.closeIFrame}
            minHeight={'85vh'}
            openOrigin={data.openOrigin}
            urlToVerify={data.urlToVerify}
            checkURLConnection={data?.checkURLConnection}
          />
        </Modal>
      )
    case ModalTypes.CONFIRMATION:
      return (
        <Modal
          title={title}
          isOpen={modalStatus}
          theme="simple"
          onClose={handleCancelClose}
        >
          <ConfirmationModal {...data} />
        </Modal>
      )

    case ModalTypes.FORM:
      return (
        <Modal
          title={title}
          isOpen={modalStatus}
          onClose={handleCancelClose}
          theme="form"
        >
          <FormModal {...data} />
        </Modal>
      )
    case ModalTypes.LOADING:
      return (
        <Modal isOpen={modalStatus} onClose={handleCancelClose}>
          <Flex justifyContent="center" alignItems="center" height="50vh">
            <Spinner />
          </Flex>
        </Modal>
      )
    case ModalTypes.RECEIPT:
      return (
        <Modal title={title} isOpen={modalStatus} onClose={close}>
          <Receipt data={data} onClose={close} />
        </Modal>
      )
    case ModalTypes.QR:
      return (
        <Modal
          title={title}
          isOpen={modalStatus}
          onClose={close}
          id="depositModal"
        >
          <QRModal data={data} onClose={close} />
        </Modal>
      )
    case ModalTypes.REGISTER:
      return (
        <Modal isOpen={modalStatus} isPage noPadding bodyMinHeight={false}>
          <RegisterModal prepopulatedInputs={data} />
        </Modal>
      )
    case ModalTypes.SIMPLE:
      return (
        <Modal
          title={title}
          isOpen={modalStatus}
          theme="simple"
          onClose={handleCancelClose}
        >
          <SimpleModal {...data} />
        </Modal>
      )

    case ModalTypes.SIMPLE2:
      return (
        <Modal
          theme="form"
          title={title}
          isOpen
          onClose={close}
          hideClose={data.hideClose}
        >
          <Simple2Modal {...data} />
        </Modal>
      )

    case ModalTypes.WITHDRAW:
      if (isLoggedIn) return <Withdraw isOpen onClose={close} />
      break

    default:
      return <></>
  }
}

ModalContainer.propTypes = {}

export { ModalContainer }
